import { getRequest, cancelPostRequest } from './DataService';
import { Api } from '../constants';
import { cancellationPayloadTypes } from '../types';

/*   
  create specific garage page data access methods, use the DataService 
  'getRequest' and 'postRequest' methods to make the actual 
  Http calls 
*/

// POST Calls

export const postCancelPreOrder: any = (
  cancellationPayload: cancellationPayloadTypes,
  env: string,
  appInsightCallback?: (params: any) => void
) => {
  const url: string = `${Api.POST_PRE_ORDER_CANCELLATION}`;
  return cancelPostRequest(url, env, cancellationPayload, appInsightCallback);
};

export const postCancelPrePurchase: any = (
  cancellationPayload: cancellationPayloadTypes,
  env: string,
  appInsightCallback?: (params: any) => void
) => {
  const url: string = `${Api.POST_PRE_PURCHASE_CANCELLATION}`;
  return cancelPostRequest(url, env, cancellationPayload, appInsightCallback);
};

// GET Calls

export const getGarageCardsDataApi: any = (env: string, appInsightCallback?: (params: any) => void) => {
  const url: string = `${Api.GET_LEFT_RAIL_CARDS_API_URI}`;
  return getRequest({ url });
};
